import {  UniqueId } from "../_uniqueId";

export default class DevicePropertyForm extends UniqueId {
    deviceId: number = 0;
    key: string = '';
    value: string='';
    fieldType: number = 0;
}